import * as React from 'react';
import { useRef, useState, useEffect } from "react";
import { CHEVRON_LEFT_SVG, FAV_SVG, FAV_FILLED_SVG, ELLIPSES_SVG, PAUSE_RUBY_SVG, PLAY_RUBY_SVG } from "../../assets";
import Loader from "../utility/Loader";
import { useHistory } from "react-router";
import DropdownMenu from "../DropdownMenu";
import Title from "../Title";
import { Popover } from "@material-ui/core";
import { DynamicPlaylist, AddToHistory, PlaybackManager, PlayerState, PlayerContextConsumer, isSoundPackagePending, CuratedPackageWrapper } from '../..';
import { debounce } from 'lodash';
var AlbumRow = function (props) {
    var albumsContainer = useRef(null);
    var albumAndTextContainer = useRef(null);
    var album = useRef(null);
    var buttonLeft = useRef(null);
    var buttonRight = useRef(null);
    var _a = useState(false), showButtonLeft = _a[0], setShowButtonLeft = _a[1];
    var _b = useState(true), showButtonRight = _b[0], setShowButtonRight = _b[1];
    var _c = useState(0), rightMargin = _c[0], setRightMargin = _c[1];
    var _d = useState(null), dropdownID = _d[0], setDropdownID = _d[1];
    var _e = useState(props.viewAll || false), viewAll = _e[0], setViewAll = _e[1];
    var _f = useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = useState(false), lastPage = _g[0], setLastPage = _g[1];
    var loadMoreDiv = useRef(null);
    var checkDivPosition = debounce(function () {
        var _a;
        if (loadMoreDiv) {
            var paging = props.paging, loading = props.loading, onLoadMore = props.onLoadMore;
            var hasMore = paging ? (paging.page * paging.limited) < paging.total : false;
            if (!hasMore || !onLoadMore || loading) {
                return;
            }
            var position = (_a = loadMoreDiv.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (position && position.top < window.innerHeight && position.bottom >= 0) {
                onLoadMore((paging.page) * paging.limited);
            }
        }
    }, 300);
    React.useEffect(function () {
        window.addEventListener('scroll', checkDivPosition);
        return function () {
            window.removeEventListener('scroll', checkDivPosition);
        };
    }, [props.paging, props.loading]);
    var history = useHistory();
    var internallist = React.useRef(new DynamicPlaylist([], {
        history_mode: AddToHistory.ALL
    }, props.context, false));
    React.useEffect(function () {
        internallist.current.replace((props.soundPackages || []).reduce(function (prev, pack) {
            if (pack.demo_file_url) {
                prev.push({
                    sound: PlaybackManager.packageToPlayableSound(pack, 1),
                    playlist: internallist.current
                });
            }
            if (pack.demo_file_url_2) {
                prev.push({
                    sound: PlaybackManager.packageToPlayableSound(pack, 2),
                    playlist: internallist.current
                });
            }
            return prev;
        }, []));
        PlaybackManager.getInstance().getContentManager().replaceLists(internallist.current);
    }, [props.soundPackages]);
    var togglePlay = function (pack, playerContext, demo) {
        if (demo === void 0) { demo = 1; }
        var mediaSelected = false;
        if (playerContext.media && playerContext.state >= PlayerState.Loading) {
            mediaSelected = PlaybackManager.isSoundEqualSoundPackage(pack, playerContext.media.sound) !== false;
        }
        if (mediaSelected) {
            PlaybackManager.getInstance().pause();
        }
        else {
            PlaybackManager.getInstance().getContentManager().replaceLists(internallist.current);
            PlaybackManager.getInstance().startTrack(internallist.current.tracks().find(function (a) { return PlaybackManager.isSoundEqualSoundPackage(pack, a.sound) == demo; }));
        }
    };
    var computeRightMargin = function () {
        if (albumsContainer.current &&
            album.current &&
            albumAndTextContainer.current) {
            var rightMarginAsArray = window
                .getComputedStyle(albumAndTextContainer.current)
                .getPropertyValue("margin-right")
                .split("");
            var rightMargin_1 = parseInt(rightMarginAsArray[0] + rightMarginAsArray[1]);
            return rightMargin_1;
        }
        return 0;
    };
    var scrollRequestCode = React.useRef(0);
    useEffect(function () {
        setRightMargin(computeRightMargin());
    }, [props.soundPackages]);
    var scrollLeft = function (element, offset, duration) {
        var start = element.scrollLeft, currentTime = 0, increment = 20;
        offset = getNewOffset(start, offset);
        var _requestCode = ++scrollRequestCode.current;
        var setPosition = function (pos) {
            element.scrollLeft = pos;
        };
        var animateScroll = function () {
            if (_requestCode !== scrollRequestCode.current) {
                return;
            }
            currentTime += increment;
            var val = easeInOutQuad(currentTime, start, offset, duration);
            setPosition(val);
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();
    };
    var easeInOutQuad = function (currentTime, startValue, offset, duration) {
        //https://stackoverflow.com/questions/52747018/horizontal-scrolling-using-buttons-in-reactjs
        currentTime /= duration / 2;
        if (currentTime < 1) {
            return (offset / 2) * currentTime * currentTime + startValue;
        }
        currentTime--;
        return ((-offset / 2) * (currentTime * (currentTime - 2) - 1) + startValue);
    };
    var getNewOffset = function (start, offset) {
        var rest = start % offset;
        return rest < Math.abs(offset) / 2
            ? offset - rest
            : offset - rest + Math.abs(offset);
    };
    var updateOffset = debounce(function () {
        if (albumsContainer.current &&
            buttonLeft.current &&
            buttonRight.current) {
            if (albumsContainer.current.scrollLeft <= 10 && showButtonLeft) { // 0...10 => hide, 11, 12.. => show it
                setShowButtonLeft(false);
            }
            else if (albumsContainer.current.scrollLeft > 10 && !showButtonLeft) {
                setShowButtonLeft(true);
            }
            var maxScrollLeft = (albumsContainer.current.scrollWidth - albumsContainer.current.clientWidth) - rightMargin;
            if (albumsContainer.current.scrollLeft < maxScrollLeft - 10) {
                setShowButtonRight(true);
            }
            else if (albumsContainer.current.scrollLeft >= maxScrollLeft) {
                setShowButtonRight(false);
            }
        }
    }, 300);
    var handleDropdown = function (id, event) {
        event.stopPropagation();
        if (id === dropdownID)
            setDropdownID(null);
        else {
            setAnchorEl(event.currentTarget);
            setDropdownID(id);
        }
    };
    var renderAutoLoadMore = function () {
        var paging = props.paging, loading = props.loading, onLoadMore = props.onLoadMore, soundPackages = props.soundPackages;
        var hasMore = paging ? (paging.page * paging.limited) < paging.total : false;
        if (!hasMore || !onLoadMore || loading) {
            if (soundPackages && soundPackages.length == 0)
                return null;
        }
        if (!hasMore && !lastPage) {
            setLastPage(true);
        }
        return React.createElement("div", { ref: loadMoreDiv });
    };
    var renderPackage = function (soundPackage, index) {
        return (React.createElement("div", { key: index, className: "album-and-text-container", ref: albumAndTextContainer, onClick: function () {
                if (soundPackage.__typename == 'Curated') {
                    props.onCuratedClick(soundPackage);
                }
                else {
                    props.onSoundPackageClick(soundPackage);
                }
            } },
            React.createElement("div", { className: "cover-container" },
                React.createElement(PlayerContextConsumer, null, function (context) {
                    var mediaSelected = false;
                    if (context.media && context.state >= PlayerState.Loading) {
                        mediaSelected = PlaybackManager.isSoundEqualSoundPackage(soundPackage, context.media.sound) !== false;
                    }
                    return React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "clickables-container", style: dropdownID === soundPackage.id ? { visibility: 'unset' } : {} },
                            React.createElement("img", { className: "heart " + (soundPackage.is_favorited ? 'no-fill' : ''), src: soundPackage.is_favorited ? FAV_FILLED_SVG : FAV_SVG, alt: "", onClick: function (e) {
                                    e.stopPropagation();
                                    if (soundPackage.__typename == 'Curated') {
                                        props.onCuratedLikeToggled && props.onCuratedLikeToggled(soundPackage);
                                    }
                                    else {
                                        props.onSoundPackageLikeToggled && props.onSoundPackageLikeToggled(soundPackage);
                                    }
                                } }),
                            React.createElement("img", { className: "ellipses no-select", src: ELLIPSES_SVG, onClick: function (event) {
                                    handleDropdown(soundPackage.id, event);
                                }, id: soundPackage.id, alt: "ellipses" }),
                            React.createElement("div", { className: 'Dropdown', style: dropdownID === soundPackage.id ? {} : { visibility: 'hidden' } },
                                React.createElement(Popover, { open: dropdownID === soundPackage.id, onClick: function (e) {
                                        e.stopPropagation();
                                        setDropdownID(null);
                                    }, anchorEl: anchorEl, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { horizontal: 'right', vertical: 'top' } },
                                    React.createElement(DropdownMenu, { menuItems: [
                                            soundPackage.demo_file_url ? {
                                                text: 'Play Demo',
                                                onClick: function () {
                                                    togglePlay(soundPackage, context);
                                                }
                                            } : undefined,
                                            soundPackage.demo_file_url_2 ? {
                                                text: 'Play Demo 2',
                                                onClick: function () {
                                                    togglePlay(soundPackage, context, 2);
                                                }
                                            } : undefined,
                                            {
                                                text: soundPackage.is_favorited ? 'Unlike' : 'Like',
                                                onClick: function () {
                                                    if (soundPackage.__typename == 'Curated') {
                                                        props.onCuratedLikeToggled && props.onCuratedLikeToggled(soundPackage);
                                                    }
                                                    else {
                                                        props.onSoundPackageLikeToggled && props.onSoundPackageLikeToggled(soundPackage);
                                                    }
                                                }
                                            },
                                            {
                                                text: 'Find Similar',
                                                onClick: function () {
                                                    history.push("/similarpacks/" + soundPackage.id);
                                                }
                                            }
                                        ] })))),
                        soundPackage.demo_file_url && React.createElement("img", { className: "play-button no-select", src: mediaSelected ? PAUSE_RUBY_SVG : PLAY_RUBY_SVG, alt: "play/pause", onClick: function (e) {
                                e.stopPropagation();
                                togglePlay(soundPackage, context);
                            } }),
                        React.createElement("img", { className: "cover" + (isSoundPackagePending(soundPackage) ? ' not-approved' : ''), src: soundPackage.artwork_url, alt: "album cover", ref: album }));
                })),
            React.createElement("div", { className: "text-container" },
                React.createElement("div", { className: "title", onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (soundPackage.__typename == 'Curated') {
                            props.onCuratedClick(soundPackage);
                        }
                        else {
                            props.onSoundPackageClick(soundPackage);
                        }
                    } }, soundPackage.name),
                React.createElement("div", { className: "genre", onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (soundPackage.Genre) {
                            history.push('genre/' + encodeURIComponent(soundPackage.Genre.name));
                        }
                    } }, soundPackage.Genre ? soundPackage.Genre.name : ''),
                React.createElement("div", { className: "label" }, soundPackage.Label ? soundPackage.Label.name : ''))));
    };
    return (React.createElement("div", { className: "AlbumRow " + (props.defaultExpanded ? 'defaultExpanded' : '') },
        React.createElement("div", { className: "header" },
            React.createElement("div", { className: "left-container" },
                React.createElement(Title, { titleText: props.title, viewAll: props.viewAll === undefined ? (viewAll ? 'less' : 'all') : undefined, onClickViewAll: function () {
                        if (props.onViewAllClick) {
                            return props.onViewAllClick();
                        }
                        viewAll ? setViewAll(false) : setViewAll(true);
                    } })),
            props.soundPackages && props.soundPackages.length <= 7 ? null :
                React.createElement("div", { className: "right-container" },
                    React.createElement("span", { className: "left-button " + (showButtonLeft ? 'background-crimson-bright cursor-pointer' : 'album-button-disabled'), style: viewAll ? { opacity: '0' } : undefined, ref: buttonLeft, onClick: function () {
                            albumsContainer.current &&
                                album.current &&
                                scrollLeft(albumsContainer.current, -album.current.offsetWidth * 4.41 - // TODO: update
                                    rightMargin, 500);
                        } },
                        React.createElement("img", { className: "no-select", src: CHEVRON_LEFT_SVG, alt: "" })),
                    React.createElement("span", { className: "right-button " + (showButtonRight ? 'background-crimson-bright cursor-pointer' : 'album-button-disabled'), ref: buttonRight, style: viewAll ? { opacity: '0' } : undefined, onClick: function () {
                            albumsContainer.current &&
                                album.current &&
                                scrollLeft(albumsContainer.current, album.current.offsetWidth * 4.41 + // TODO: update
                                    rightMargin, 500);
                        } },
                        React.createElement("img", { className: "no-select", src: CHEVRON_LEFT_SVG, alt: "" })))),
        (function () {
            var soundPackages = props.soundPackages, emptyPlaceholder = props.emptyPlaceholder;
            if (soundPackages) {
                if (soundPackages.length === 0 && !emptyPlaceholder) {
                    return React.createElement("div", { className: "no-packs" }, "No Packs Available Yet");
                }
                else if (soundPackages.length === 0 && emptyPlaceholder) {
                    return React.createElement("div", { className: "no-packs" }, emptyPlaceholder);
                }
                else {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "content albums-container no-scrollbar", ref: albumsContainer, onScroll: updateOffset, style: {
                                gridTemplateColumns: props.defaultExpanded ? 'repeat(auto-fill, minmax(22rem, 195px))' : '',
                                flexWrap: viewAll ? 'wrap' : 'unset'
                            } },
                            props.soundPackages != undefined && props.soundPackages.map(function (soundPackage, index) {
                                return (React.createElement(CuratedPackageWrapper, { key: soundPackage.id, curated: soundPackage }, function (soundPackage) {
                                    return renderPackage(soundPackage, index);
                                }));
                            }),
                            props.loading && (props.soundPackages == undefined || props.soundPackages.length == 0) && React.createElement(Loader, { centered: true }),
                            renderAutoLoadMore()),
                        React.createElement("div", { style: props.defaultExpanded && lastPage ? {} : { display: 'none' }, className: "end-text" }, "End of Packs")));
                }
            }
            return null;
        })()));
};
export default AlbumRow;
//# sourceMappingURL=AlbumRow.js.map